var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossEnter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.072 2.91148L12.1099 4.90596L7.10357 9.89397L3.92231 13.0637L3 12.1414L6.16158 8.9683L13.1606 2L13.6163 2.45575L14.072 2.91148Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.00022 2.91148L4.9624 4.90596L9.96869 9.89397L13.15 13.0637L14.0723 12.1414L10.9107 8.9683L3.91164 2L3.45593 2.45575L3.00022 2.91148Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossEnter);
export default __webpack_public_path__ + "static/media/cross-enter.77bf55548e143d7d026d26748eff03ea.svg";
export { ForwardRef as ReactComponent };